import React from "react";
import styled, { css } from "styled-components";
import PropTypes from "prop-types";

import Close from "core/ReusableIcons/Close";
import CaretLeft from "core/ReusableIcons/CaretLeft";

import { Section, fullWidthStyles } from "core/Layout";
import Flexbox from "core/Flexbox";
import { A, H2 } from "core/Typography";
import Button from "core/Button";
import { OldGrid, Row, Col } from "core/oldGrid";
import colors from "core/colors";

export const ArrowLeftIcon = styled(CaretLeft)`
    cursor: pointer;
`;

export const CloseIcon = styled(Close)`
    width: 1.25rem;
    cursor: pointer;
`;

export const HeaderContent = styled(Flexbox)``;

export const Header = styled(Section)`
    ${fullWidthStyles}
    background-color: ${colors.primary.snow};
    padding-top: 1.1875rem;
    padding-bottom: 1.1875rem;
    border-bottom: 1px solid ${colors.secondary.oolong};
`;

export const linkHeadingStyles = css`
    padding-top: 1.3125rem;
    padding-bottom: 0.8125rem;
    color: ${colors.secondary.oolong};
`;

let ItemHeading = ({ className, children }) => (
    <Section className={className}>
        <ContainedGrid>
            <H2 size={12}>{children}</H2>
        </ContainedGrid>
    </Section>
);

ItemHeading = styled(ItemHeading)`
    ${linkHeadingStyles}
`;
export { ItemHeading };

let ContainedGrid = ({ children, className }) => (
    <OldGrid className={className}>
        <Row>
            <Col sm={12}>{children}</Col>
        </Row>
    </OldGrid>
);

ContainedGrid = styled(ContainedGrid)``;
export { ContainedGrid };

const Team = styled(A)`
    padding-top: 0.625rem;
`;

let Teams = ({ teams, className }) => (
    <div className={className}>
        {teams.map(team => (
            <Team
                key={team.username}
                href={`/${team.username}/settings/seats/`}
            >
                {team.name}
            </Team>
        ))}
    </div>
);

Teams = styled(Teams)``;

Teams.propTypes = {
    teams: PropTypes.array
};

export { Teams };

export const itemStyles = css`
    background-color: ${colors.primary.snow};
    ${fullWidthStyles}
    margin-bottom: 0.25rem;

    a {
        text-decoration: none;
        display: block;
        color: ${colors.secondary.onyx};

        &:hover {
            color: ${colors.secondary.oolong};
        }
    }

    ${Section} {
        ${fullWidthStyles}
        padding-top: 0.8125rem;
        padding-bottom: 0.75rem;
    }
`;

let Item = ({ children, className, noLink, ...anchorProps }) => {
    return (
        <li className={className}>
            {noLink ? (
                <Section>
                    <ContainedGrid>{children}</ContainedGrid>
                </Section>
            ) : (
                <A {...anchorProps}>
                    <Section>
                        <ContainedGrid>{children}</ContainedGrid>
                    </Section>
                </A>
            )}
        </li>
    );
};

Item = styled(Item)`
    ${itemStyles}
`;

Item.propTypes = {
    href: PropTypes.string,
    noLink: PropTypes.bool,
    onClick: PropTypes.func
};

export { Item };

export const Items = styled.ul``;

export const openMobileMenuStyles = css`
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100vw;
    overflow-y: auto;
    overflow-x: hidden;
`;

export const LogOutButton = styled(Button)``;

export const Wrapper = styled.div`
    height: 100vh;
    background-color: ${colors.primary.diamond};
    color: ${colors.secondary.onyx};

    ${LogOutButton} {
        margin: 1rem 0;
    }
`;

// for iOS scrolling:
export const MobileSpacing = styled.div`
    height: 125px;
`;
